import { Input } from "@shadcn-in-nx/ui/input";
import { Label } from "@shadcn-in-nx/ui/label";
import { Upload } from "lucide-react";
import { useId } from "react";
import { FileList } from "./FileList";

export function Dropzone({ onChange, files, multiple, accept }) {
    const idForInput = useId();
    const handleChange = (e) => {
        const files = e.target.files;
        onChange(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const droppedFiles = e.dataTransfer.files;
        onChange(droppedFiles);
    };

    return (
        <div>
            <Label
                htmlFor={idForInput}
                className="group h-[200px] bg-slate-50 border-2 rounded border-dashed grid place-content-center cursor-pointer"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <div className="flex flex-col items-center gap-4">
                    <Upload size={40} className="text-slate-300" />
                    <h3
                        htmlFor={idForInput}
                        className="text-muted-foreground font-medium"
                    >
                        Drop item here or{" "}
                        <span className="group-hover:underline">
                            select file
                        </span>
                    </h3>
                    <Input
                        id={idForInput}
                        type="file"
                        className="hidden"
                        onChange={handleChange}
                        multiple={multiple}
                    />
                </div>
            </Label>
            <FileList files={files} />
        </div>
    );
}
